/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
import TOOLTIP from '../../../../constants/artifact_tooltip.constant';
import MESSAGES from '../../../../constants/configuration_messages.constants';
import ACTIONS from '../../../../constants/user_actions.constants';
import DestinationsEffectivePermissionModel from '../../../../models/DestinationsEffectivePermissionModel';

export class AdminSecurityUserFormController {
    constructor($scope, $state, $stateParams, $timeout, $q, $http, RESOURCE, JFrogGridFactory, UserDao, GroupsDao,
                GroupPermissionsDao, AdminSecurityGeneralDao, User, uiGridConstants, commonGridColumns, ArtifactoryModelSaver,
                RepositoriesDao, UserProfileDao, JFrogModal, JFrogNotifications, ArtifactoryState, JFrogTableViewOptions,
                DistributionPermissionsDAO, $window, AppContext, PipelinesPermissionsDao, ArtifactoryFeatures, ProjectAdminDao) {

        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$http = $http;
        this.RESOURCE = RESOURCE;
        this.User = User;
        this.repositoriesDao = RepositoriesDao;
        this.adminSecurityGeneralDao = AdminSecurityGeneralDao;
        this.modal = JFrogModal;
        this.userDao = UserDao.getInstance();
        this.groupsDao = GroupsDao.getInstance();
        this.disributionPermissionsDAO = DistributionPermissionsDAO.Resource;
        this.groupPermissionsDao = GroupPermissionsDao.getInstance();
        this.pipelinesPermissionsDao = PipelinesPermissionsDao.getInstance();
        this.projectAdminDao = ProjectAdminDao.getInstance();
        this.artifactoryGridFactory = JFrogGridFactory;
        this.JFrogTableViewOptions = JFrogTableViewOptions;
        this.ArtifactoryModelSaver = ArtifactoryModelSaver.createInstance(this, ['userdata', 'input'], ['locked']);
        this.reposPermissionsOptions = {};
        this.buildsPermissionsOptions = {};
        this.bundlesPermissionsOptions = {};
        this.destinationsPermissionsOptions = {};
        this.userProfileDao = UserProfileDao;
        this.uiGridConstants = uiGridConstants;
        this.commonGridColumns = commonGridColumns;
        this.artifactoryNotifications = JFrogNotifications;
        this.AppContext = AppContext;
        this.features = ArtifactoryFeatures;
        this.TOOLTIP = TOOLTIP.admin.security.usersForm;
        this.MESSAGES = MESSAGES.admin.security.users.userForm;
        this.input = {};
        this.artifactoryState = ArtifactoryState;
        this.emailChanged = false;
        this.setDisabledChecked = true;
        this.passwordRank = 0;
        this.lastSavedUserSettings = {};
        this.$window = $window;
        this.nameCellTemplate = require('./permission.name.template.html');
        this.getEffectivePermissionSwitchTabs();
        this._getPasswordExpirationState();
        this.isSaas = this.AppContext.isSaas();

        if ($stateParams.username) {
            this.mode = 'edit';
            this.username = $stateParams.username;
            this.title = 'Edit ' + this.username + ' User';
            this._getUserData();

        } else {
            this.mode = 'create';
            this.title = 'Add New User';
            this.userdata = {
                groups: [],
                profileUpdatable: true,
                disableUIAccess: false,
                internalPasswordDisabled: false,
                watchManager: false,
                reportsManager: false,
                policyManager: false,
            };
            this.saveCheckboxes();
        }
        this._createGrid();
        this._getAllRepos();
        this._getAllGroups();
    }

    $onInit() {
        this.adminManagementRoutes = window.store.getters['appLayout/GET_ADMIN_MANAGEMENT_ROUTES'];
        this.projectAdmin = false;
        this.entityType = 'user';
        if (this.username && this.shouldShowProjectAdminRole()) { // in case mode is 'edit' and not 'create'
            this.fetchIsProjectAdmin();
        }
    }

    shouldShowProjectAdminRole() {
        return this.features.isEnterprisePlus() || this.features.isEnterprise();
    }

    fetchIsProjectAdmin() {
        const { username: entityName, entityType } = this;
        this.projectAdminDao.isProjectAdmin({ entityType, entityName, userGroupsApply: false }).$promise.then(({ data }) => {
            if(!this.userdata.admin){
                this.projectAdmin = data;
            }else{
                this.projectAdmin = true;
            }

        });
    }

    toggleProjectAdmin() {
        const entityName = this.userdata.name;
        const { entityType } = this;
        let method = this.projectAdminDao.unsetEntityAsProjectAdmin;
        if (this.projectAdmin) {
            method = this.projectAdminDao.setEntityAsProjectAdmin;
        }
        method({}, { entityType, entityName }).$promise
            .then().catch(({ data: error }) => {
            console.error(error);
            window.store.dispatch('CREATE_NOTIFICATION', { error });
        });
    }
    setProjectAdminToggledFlag() {
        this.wasProjectAdminRoleChanged = true;
    }

    getEffectivePermissionSwitchTabs() {
        this.switchOptions = ['Repositories', 'Builds'];
        if (this.AppContext.hasPlatformLicense()) {
            this.switchOptions = this.switchOptions.concat(['Release Bundles']);
        }
        if (this.AppContext.hasDistribution() && this.AppContext.hasPlatformLicense()) {
            this.switchOptions = this.switchOptions.concat(['Destinations']);
        }
        if (this.AppContext.hasPipelines()) {
            this.switchOptions = this.switchOptions.concat(['Pipelines']);
        }
    }

    userIsEffectiveAdmin() {
        return (this.userdata.admin || this.isInAdminGroup);
    }

    _getAllRepos() {
        this.reposData = {};
        this.repositoriesDao.getRepositories({ type: 'local' }).$promise
            .then((data) => {
                this.reposData.locals = _.map(data, (r) => {
                    return r.repoKey;
                });
            });
        this.repositoriesDao.getRepositories({ type: 'remote' }).$promise
            .then((data) => {
                this.reposData.remotes = _.map(data, (r) => {
                    return r.repoKey;
                });
            });
        this.repositoriesDao.getRepositories({ type: 'distribution' }).$promise
            .then((data) => {
                this.reposData.dists = _.map(data, (r) => {
                    return r.repoKey;
                });
            });
    }

    _createGrid() {
        // TODO: Hide manage permissions if not default project
        this.initBuildsPermissions();
        this.initRepositoriesPermissions();
        this.initBundlesPermissions();
        this.initDestinationsPermissions();
        this.initPipelinesPermissions();
    }

    initRepositoriesPermissions() {
        this.reposPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.reposPermissionsOptions.setColumns(this.getReposPermissionsColumns());
        this.reposPermissionsOptions.setRowsPerPage(5);
        this.reposPermissionsOptions.setEmptyTableText('No Repositories Permissions were configured.');
        this.reposPermissionsOptions.setObjectName('Permission');
        this.reposPermissionsOptions.sortBy('permissionName');
        this.reposPermissionsOptions.reverseSortingDir();
    }

    initBuildsPermissions() {
        this.buildsPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.buildsPermissionsOptions.setColumns(this.getBuildsPermissionsColumns());
        this.buildsPermissionsOptions.setRowsPerPage(5);
        this.buildsPermissionsOptions.setEmptyTableText('No Builds Permissions were configured.');
        this.buildsPermissionsOptions.setObjectName('Permission');
        this.buildsPermissionsOptions.sortBy('permissionName');
        this.buildsPermissionsOptions.reverseSortingDir();
    }

    initBundlesPermissions() {
        this.bundlesPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.bundlesPermissionsOptions.setColumns(this.getBundlesPermissionsColumns());
        this.bundlesPermissionsOptions.setRowsPerPage(5);
        this.bundlesPermissionsOptions.setEmptyTableText('No Release Bundle Permissions were configured.');
        this.bundlesPermissionsOptions.setObjectName('Permission');
        this.bundlesPermissionsOptions.sortBy('permissionName');
        this.bundlesPermissionsOptions.reverseSortingDir();
        this.bundlesPermissionsOptions.setData([]);
    }

    initDestinationsPermissions() {
        this.destinationsPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.destinationsPermissionsOptions.setColumns(this.getDestinationsPermissionsColumns());
        this.destinationsPermissionsOptions.setRowsPerPage(5);
        this.destinationsPermissionsOptions.setEmptyTableText('No Destination Permissions were configured.');
        this.destinationsPermissionsOptions.setObjectName('Permission');
        this.destinationsPermissionsOptions.sortBy('permissionName');
        this.destinationsPermissionsOptions.reverseSortingDir();
        this.destinationsPermissionsOptions.setData([]);
    }

    initPipelinesPermissions() {
        this.pipelinesPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.pipelinesPermissionsOptions.setColumns(this.getPipelinesPermissionsColumns());
        this.pipelinesPermissionsOptions.setRowsPerPage(5);
        this.pipelinesPermissionsOptions.setEmptyTableText('No Pipeline Sources Permissions were configured.');
        this.pipelinesPermissionsOptions.setObjectName('Permission');
        this.pipelinesPermissionsOptions.sortBy('permissionName');
        this.pipelinesPermissionsOptions.reverseSortingDir();
        this.pipelinesPermissionsOptions.setData([]);
    }

    onNameClick({ permissionName }) {
        this.$window.$vueRouter.push({
            name: 'admin.management.permissions.edit',
            params: { permissionName },
        });
    }

    getReposPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%',
            },
            {
                field: 'repoKeys',
                header: 'Repositories',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.repoKeys', 'row.entity.permissionName'),
                width: '13%',
                filterable: false,
            },
            {
                field: 'effectivePermission.read',
                header: 'Read',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read'),
                width: '8%',
                filterable: false,
            },
            {
                field: 'effectivePermission.deploy',
                header: 'Deploy/Cache',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                width: '14%',
                filterable: false,
            },
            {
                field: 'effectivePermission.delete',
                header: 'Delete/Overwrite',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.annotate',
                header: 'Annotate',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                width: '9%',
                filterable: false,
            },
            {
                field: 'effectivePermission.managedXrayMeta',
                header: 'Manage Xray Meta',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense(),
            },
            {
                field: 'effectivePermission.managed',
                header: 'Manage',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                width: '10%',
                filterable: false,
            },
        ];
    }

    getBuildsPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%',
            },
            {
                field: 'effectivePermission.principal',
                header: 'Applied To',
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.read',
                header: 'Read',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.deploy',
                header: 'Deploy',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.delete',
                header: 'Delete',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.annotate',
                header: 'Annotate',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.managedXrayMeta',
                header: 'Manage Xray Meta',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense(),
            },
            {
                field: 'effectivePermission.managed',
                header: 'Manage',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                width: '10%',
                filterable: false,
            },
        ];
    }

    getBundlesPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%',
            }, {
                field: 'effectivePermission.principal',
                header: 'Applied To',
                cellTemplate: `<div class="latest-version">
									{{row.entity.effectivePermission.principal}}
								</div>`,
                width: '15%',
            }, {
                field: 'effectivePermission.read',
                header: 'Read',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read', 'row.entity.name'),
                width: '10%',
                filterable: false,
            }, {
                field: 'effectivePermission.deploy',
                header: 'Create',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                width: '10%',
                filterable: false,
            }, {
                field: 'effectivePermission.delete',
                header: 'Delete',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                width: '10%',
                filterable: false,
            }, {
                field: 'effectivePermission.annotate',
                header: 'Annotate',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                width: '15%',
                filterable: false,
            }, {
                field: 'effectivePermission.distribute',
                header: 'Distribute',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.distribute'),
                width: '15%',
                filterable: false,
            },
            {
                field: 'effectivePermission.managedXrayMeta',
                header: 'Manage Xray Meta',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense(),
            },
            {
                field: 'effectivePermission.managed',
                header: 'Manage',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                width: '10%',
                filterable: false,
            },
        ];
    }

    getDestinationsPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%',
            }, {
                field: 'jpus',
                header: 'JPUs',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.jpus', 'row.entity.permissionName'),
                width: '20%',
                filterable: false,
            }, {
                field: 'distribute',
                header: 'Distribute',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.distribute'),
                width: '15%',
                filterable: false,
            }, {
                field: 'delete',
                header: 'Delete',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.delete'),
                width: '15%',
                filterable: false,
            }, {
                field: 'managed',
                header: 'Manage',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.managed'),
                width: '15%',
                filterable: false,
            },
        ];
    }

    getPipelinesPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%',
            },
            {
                field: 'pipelineSources',
                header: 'Pipeline Sources',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.pipelineSources', 'row.entity.permissionName'),
                width: '30%',
                filterable: false,
            },
            {
                field: 'read',
                header: 'Read',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.read'),
                width: '8%',
                filterable: false,
            },
            {
                field: 'trigger',
                header: 'Trigger',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.trigger'),
                width: '14%',
                filterable: false,
            },
            {
                field: 'managed',
                header: 'Manage',
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.managed'),
                width: '10%',
                filterable: false,
            },
        ];
    }

    _getAllGroups() {
        this.userDao.getAllGroups().$promise.then((data) => {
            this.groupsData = data;
            this.groupsList = _.map(this.groupsData, (group) => {
                if (group.autoJoin && this.mode === 'create') {
                    this.userdata.groups.push(group.groupName);
                    this.ArtifactoryModelSaver.save();
                }
                return group.groupName;
            });
            if (this.mode === 'create') {
                this._getGroupsPermissions();
            }

            this.groupDndTemplate = `<div style="min-width:200px">
                                        {{getItemInfo().text}}
                                        <i ng-if="userScope.UserForm.groupIsAdmin(getItemInfo().text)"
                                           jf-tooltip="Admin Privileges"
                                           class="icon icon-admin-new pull-left"></i>
                                        <i ng-if="!userScope.UserForm.groupIsAdmin(getItemInfo().text)"
                                            class="icon icon-blank pull-left"></i>
                                    </div>`;
        });
    }

    async _getUserPermissions() {
        this.userDao.getPermissions({ userOnly: true }, { name: this.username }).$promise.then((data) => {
            this.userRepoPermissions = data.repoPermissions;
            this.userBuildPermissions = data.buildPermissions;
            this.userReleaseBundlePermissions = data.releaseBundlePermissions;
            if (!this.userdata.groups
                || !this.userdata.groups.length
                || this.groupsRepoPermissions
                || this.groupsBuildPermissions
                || this.groupsBundlePermissions) {
                this._setGridData();
            }
        });

        if (this.AppContext.isDistributionUp()) {
            try {
                await this._getDestinationsUserData();
                this.AppContext.setPairingStatus(true);
                if (!this.userdata.groups
                    || !this.userdata.groups.length
                    || this.groupsDestinationsPermissions) {
                    this._setDestinationsGridData();
                }
            } catch (e) {
                console.error(e);
            }
        }
        if (this.AppContext.isPipelinesUp()) {
            try {
                await this._getPipelinesUserData();
                if (!this.userdata.groups
                    || !this.userdata.groups.length
                    || this.groupsPipelinesPermissions) {
                    this._setPipelinesGridData();
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    async _getDestinationsUserData() {
        const payload = {
            users: [this.username],
            groups: [],
            //num_of_results_per_permission: 10
        };
        this.userDestinationPermissions = [];
        await this.disributionPermissionsDAO.getDestinationsEffectivePermissions({ $no_spinner: true }, payload).$promise.then(response => {
            if (response && response.length) {
                this.userDestinationPermissions = response.map(dest => new DestinationsEffectivePermissionModel(dest));
            }
        });
    }

    async _getDestinationsGroupsData() {
        const payload = {
            users: [],
            groups: this.userdata.groups,
            //num_of_results_per_permission: 10
        };
        this.groupsDestinationsPermissions = [];
        await this.disributionPermissionsDAO.getDestinationsEffectivePermissions({ $no_spinner: true }, payload).$promise.then(response => {
            if (response && response.length) {
                this.groupsDestinationsPermissions = response.map(dest => new DestinationsEffectivePermissionModel(dest));
            }
        });
    }

    async _getPipelinesUserData() {
        const payload = {
            users: [this.username],
            groups: [],
        };
        this.userPipelinesPermissions = [];
        await this.pipelinesPermissionsDao.getPipelinesEffectivePermissions(payload).$promise.then(response => {
            const { effectivePermissions = [] } = response;
            this.userPipelinesPermissions = effectivePermissions;
        });
    }

    async _getPipelinesGroupsData() {
        const payload = {
            users: [],
            groups: this.userdata.groups,
        };
        this.groupsPipelinesPermissions = [];
        await this.pipelinesPermissionsDao.getPipelinesEffectivePermissions(payload).$promise.then(response => {
            const { effectivePermissions = [] } = response;
            this.groupsPipelinesPermissions = effectivePermissions;
        });
    }

    async _getGroupsPermissions() {
        if (!this.userdata) return;
        if (!this.userdata.groups || !this.userdata.groups.length) {
            this.groupsRepoPermissions = [];
            this.groupsBuildPermissions = [];
            this.groupsBundlePermissions = [];
            this.groupsDestinationsPermissions = [];
            this.groupsPipelinesPermissions = [];
            if (this.mode === 'create') {
                this.reposPermissionsOptions.setData(this.groupsRepoPermissions);
                this.buildsPermissionsOptions.setData(this.groupsBuildPermissions);
                this.bundlesPermissionsOptions.setData(this.groupsBundlePermissions);
                this.destinationsPermissionsOptions.setData(this.groupsDestinationsPermissions);
                this.pipelinesPermissionsOptions.setData(this.groupsPipelinesPermissions);
            } else {
                if (this.userRepoPermissions
                    || this.userBuildPermissions
                    || this.userReleaseBundlePermissions) {
                    this._setGridData();
                }
                if (this.AppContext.isDistributionUp()) {
                    this._setDestinationsGridData();
                }
                if (this.AppContext.isPipelinesUp()) {
                    this._setPipelinesGridData();
                }
            }
        } else {
            this.groupPermissionsDao.get({ groups: this.userdata.groups }).$promise.then((data) => {
                this.groupsRepoPermissions = data.repoPermissions;
                this.groupsBuildPermissions = data.buildPermissions;
                this.groupsBundlePermissions = data.releaseBundlePermissions;
                if (this.mode === 'create') {
                    this.reposPermissionsOptions.setData(this.groupsRepoPermissions);
                    this.buildsPermissionsOptions.setData(this.groupsBuildPermissions);
                    this.bundlesPermissionsOptions.setData(this.groupsBundlePermissions);
                } else if (this.userRepoPermissions || this.userBuildPermissions) {
                    this._setGridData();
                }
            });
            if (this.AppContext.isDistributionUp()) {
                try {
                    await this._getDestinationsGroupsData();
                    this.AppContext.setPairingStatus(true);
                    this._setDestinationsGridData();
                } catch (e) {
                    console.error(e);
                }
            }
            if (this.AppContext.isPipelinesUp()) {
                try {
                    await this._getPipelinesGroupsData();
                    this._setPipelinesGridData();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    }

    _setDestinationsGridData() {
        this.userDestinationPermissions = this.userDestinationPermissions || [];
        const groupDestinationPermissions = this.groupsDestinationsPermissions || [];
        this.destinationsPermissionsOptions.setData(this.userDestinationPermissions.concat(groupDestinationPermissions));
    }

    _setPipelinesGridData() {
        this.userPipelinesPermissions = this.userPipelinesPermissions || [];
        const groupsPipelinesPermissions = this.groupsPipelinesPermissions || [];
        this.pipelinesPermissionsOptions.setData(this.userPipelinesPermissions.concat(groupsPipelinesPermissions));
    }

    _setGridData() {
        const groupsRepoPermissions = this.groupsRepoPermissions || [];
        const groupsBuildPermissions = this.groupsBuildPermissions || [];
        const groupsBundlePermissions = this.groupsBundlePermissions || [];
        this.buildsPermissionsOptions.setData(this.userBuildPermissions.concat(groupsBuildPermissions));
        this.bundlesPermissionsOptions.setData(this.userReleaseBundlePermissions.concat(groupsBundlePermissions));

        this._fixDataFormat(this.userRepoPermissions).then((fixedData) => {
            this.reposPermissionsOptions.setData(fixedData.concat(groupsRepoPermissions));
        });
    }

    _fixDataFormat(data, defer = null) {
        defer = defer || this.$q.defer();
        if (this.reposData.locals && this.reposData.remotes) {
            data.forEach((record) => {
                if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY LOCAL') {
                    record.repoKeysView = 'ANY LOCAL';
                    record.reposList = angular.copy(this.reposData.locals);
                } else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY REMOTE') {
                    record.repoKeysView = 'ANY REMOTE';
                    record.reposList = angular.copy(this.reposData.remotes);
                } else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY DISTRIBUTION') {
                    record.repoKeysView = 'ANY DISTRIBUTION';
                    record.reposList = angular.copy(this.reposData.dists);
                } else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY') {
                    record.repoKeysView = 'ANY';
                    record.reposList = angular.copy(this.reposData.remotes).concat(this.reposData.locals).concat(this.reposData.dists);
                } else if (record.repoKeys) {
                    record.repoKeysView = record.repoKeys.join(', ');
                    record.reposList = angular.copy(record.repoKeys);
                }
            });
            defer.resolve(data);
        } else {
            this.$timeout(() => {
                this._fixDataFormat(data, defer);
            });
        }
        return defer.promise;
    }

    _getUserData() {
        this.userDao.getSingle({ name: this.username }).$promise.then((data) => {
            this.userdata = data.data;
            this._getUserPermissions();
            this.isInAdminGroup = this.userdata.groupAdmin;

            if (this.userdata.internalPasswordDisabled) {
                this.passwordOriginalyDisabled = true;
            }
            if (!this.userdata.groups) {
                this.userdata.groups = [];
            } else {
                this._getGroupsPermissions();
            }
            this.saveCheckboxes();
            this.ArtifactoryModelSaver.save();
        });
        this._getApiKeyState();
    }

    async resetMfaEnroll() {
        try {
            const user = this.username;
            await window.store.dispatch('usersManagement/RESET_USER_MFA_STATUS', this.username);
            this._getUserData();
            this.artifactoryNotifications.create({
                info: `Successfully reset ${user} Google MFA enrollment`,
            });
        } catch (e) {
            console.error(e);
        }
    }

    _getApiKeyState() {
        const realm = store.getters.GET_USERDATA.realm;
        this.userProfileDao.hasApiKey({
            $no_spinner: true,
            realm,
        }, { username: this.username }).$promise.then((res) => {
            this.apiKeyExist = true;
        }).catch(() => {
            this.apiKeyExist = false;
        });
    }

    _fixGroups(userdata) {
        let groups = userdata.groups;
        let groupsObjects = [];
        groups.forEach((group) => {
            let realm = _.find(this.groupsData, { groupName: group }).realm;
            groupsObjects.push({ groupName: group, realm: realm });
        });
        delete (userdata.groups);
        userdata.userGroups = groupsObjects;
    }

    onEmailChanged() {
        this.emailChanged = true;
    }

    fetchAllUsers() {
        window.store.dispatch('usersManagement/FETCH_USERS');
    }


    updateUser() {
        return this.$q((resolve, reject) => {
            let payload = angular.copy(this.userdata);
            _.extend(payload, this.input);
            this._fixGroups(payload);
            this.userDao.update({ name: this.userdata.name }, payload).$promise.then((data) => {
                this.savePending = false;
                if (this.userdata.name === this.User.currentUser.name) {
                    if (this.emailChanged) {
                        this.artifactoryState.removeState('setMeUpUserData');
                    }
                    this.User.reload();
                }
                this.ArtifactoryModelSaver.save();
                window.$vueRouter.push({ name: this.adminManagementRoutes.USERS.LIST });
                this.fetchAllUsers();
                resolve();
            }).catch(() => {
                this.savePending = false;
                reject();
            });
        });
    }

    createNewUser() {
        return this.$q((resolve, reject) => {
            let payload = angular.copy(this.userdata);
            _.extend(payload, this.input);
            this._fixGroups(payload);
            this.userDao.create(payload).$promise.then((data) => {
                this.savePending = false;
                this.ArtifactoryModelSaver.save();
                window.$vueRouter.push({ name: this.adminManagementRoutes.USERS.LIST });
                this.fetchAllUsers();
                resolve();
            }).catch(() => {
                this.savePending = false;
                reject();
            });
        });
    }

    save() {
        if (this.userForm.$pending || this.userForm.$invalid || this.savePending) {
            return false;
        }

        this.savePending = true;
        let actionResolved = null;
        if (this.mode === 'edit') {
            actionResolved = this.updateUser();
        }
        if (this.mode === 'create') {
            actionResolved = this.createNewUser();
        }
        actionResolved.then(() => {
            if (this.wasProjectAdminRoleChanged && this.shouldShowProjectAdminRole()) {
                this.toggleProjectAdmin();
            }
        });
    }

    cancel() {
        this.fetchAllUsers();
        window.$vueRouter.go(-1);
    }

    deleteUser() {
        let json = { userNames: [this.username] };
        this.modal.confirm(`Are you sure you want to delete user '${this.username}?'`)
            .then(() => this.userDao.delete(json).$promise.then(() => this.cancel()));
    }

    userIsInAdminGroup() {
        let groups = this.userdata.groups;
        let groupsData = this.groupsData;
        for (let i in groups) {
            for (let j = 0; j < groupsData.length; j++) {
                if (groupsData[j].name === groups[i]
                    && groupsData[j].adminPrivileges) {
                    return true;
                }
            }
        }
        return false;
    }

    groupIsAdmin(group) {
        return _.find(this.groupsData, { groupName: group, adminPrivileges: true });
    }

    onCheckboxChanged() {
        this.saveCheckboxes();
    }

    saveCheckboxes() {
        this.lastSavedUserSettings = {
            disableUIAccess: this.userdata.disableUIAccess,
            profileUpdatable: this.userdata.profileUpdatable,
            internalPasswordDisabled: this.userdata.internalPasswordDisabled,
            watchManager: this.userdata.watchManager,
            reportsManager: this.userdata.reportsManager,
            policyManager: this.userdata.policyManager,
        };
        if (this.userdata.admin) {
            this.userdata.profileUpdatable = true;
            this.userdata.internalPasswordDisabled = false;
            this.userdata.disableUIAccess = false;
            this.projectAdmin = true;
            this.userdata.watchManager = true;
            this.userdata.reportsManager = true;
            this.userdata.policyManager = true;
           }
        }

    onChangeGroups() {
        this._getGroupsPermissions();
        if (this.mode === 'edit') this._getUserPermissions();
        this.$timeout(() => {
            this.isInAdminGroup = this.userIsInAdminGroup();
            // Save last user settings before making changes
            if (this.isInAdminGroup || this.userdata.admin) {
                this.userdata.disableUIAccess = false;
                this.userdata.profileUpdatable = true;
                this.userdata.internalPasswordDisabled = false;
            } else {
                this.userdata.disableUIAccess = this.lastSavedUserSettings.disableUIAccess;
                this.userdata.profileUpdatable = this.lastSavedUserSettings.profileUpdatable;
                this.userdata.internalPasswordDisabled = this.lastSavedUserSettings.internalPasswordDisabled;
            }
        });
    }

    onClickAdmin() {
        if (this.userdata.admin) {
            this.userdata.profileUpdatable = true;
            this.userdata.internalPasswordDisabled = false;
            this.userdata.disableUIAccess = false;
            this.projectAdmin = true;
            this.userdata.watchManager = true;
            this.userdata.reportsManager = true;
            this.userdata.policyManager = true;

        }else{
            this.projectAdmin = false;
            this.userdata.watchManager = false;
            this.userdata.reportsManager = false;
            this.userdata.policyManager = false;
        }
    }

    isSaveDisabled() {
        return this.savePending || !this.userForm || this.userForm.$invalid || this.userForm.$pending || ((this.input.password || this.input.retypePassword) && (this.input.password !== this.input.retypePassword));
    }

    checkPwdMatch(retypeVal) {
        return !retypeVal || (retypeVal && this.input.password === retypeVal);
    }

    isAnonymous() {
        return this.userdata.name === 'anonymous';
    }

    revokeApiKey() {
        const realm = store.getters.GET_USERDATA.realm;
        this.modal.confirm(`Are you sure you want to revoke API key for this user ?`)
            .then(() => {
                this.userProfileDao.revokeApiKey({ realm }, { username: this.username }).$promise.then(() => {
                    this.apiKeyExist = false;
                });

            });
    }

    unlockUser() {
        this.adminSecurityGeneralDao.unlockUsers({}, [this.username]).$promise.then((res) => {
            if (res.status === 200) {
                this.userdata.locked = false;
            }
        });
    }


    expirePassword() {
        this.modal.confirm(`Are you sure you want to expire this user's password?`)
            .then(() => {
                this.userDao.expirePassword({}, { username: this.username }).$promise.then(() => {
                    this._getUserData();
                });
            });
    }

    unexpirePassword() {
        this.userDao.unExpirePassword({}, { username: this.username }).$promise.then(() => {
            this._getUserData();
        });
    }

    _getPasswordExpirationState() {
        this.adminSecurityGeneralDao.get().$promise.then((data) => {
            this.passwordExpirationEnabled = data.passwordSettings.expirationPolicy.enabled;
            this.userLockEnabled = data.userLockPolicy.enabled;
        });
    }

    revokeApiKey() {
        const realm = store.getters.GET_USERDATA.realm;
        this.modal.confirm(`Are you sure you want to revoke API key for user '${this.username}'?`)
            .then(() => {
                this.userProfileDao.revokeApiKey({ realm }, { username: this.username }).$promise.then(() => {
                    this._getApiKeyState();
                });
            });
    }

    clearPasswordFields() {
        delete this.input.password;
        delete this.input.retypePassword;
    }

    onChangePasswordDisabled() {
        if (this.userdata.internalPasswordDisabled) {
            this.changePassword = false;
            this.clearPasswordFields();
            this.passwordReEnabled = false;
        } else {
            if (this.passwordOriginalyDisabled) {
                this.passwordReEnabled = true;
            }
        }
        this.onCheckboxChanged();
    }

    initActions(actionsController) {

        this.actionsController = actionsController;
        actionsController.setActionsDictionary(ACTIONS);
        actionsController.setActions([
            {
                name: 'RevokeApiKey',
                visibleWhen: () => this.userdata && this.apiKeyExist && this.userdata.name !== 'anonymous',
                action: () => this.revokeApiKey(),
            },
            {
                name: 'UnlockUser',
                visibleWhen: () => this.userdata && this.userdata.locked && this.userdata.name !== 'anonymous',
                action: () => this.unlockUser(),
            },
            {
                name: 'ExpirePassword',
                visibleWhen: () => this.userdata && this.passwordExpirationEnabled && this.mode === 'edit' && !this.userdata.credentialsExpired && (this.userdata.realm === 'internal' || !this.userdata.realm) && this.userdata.name !== 'anonymous',
                action: () => this.expirePassword(),
            },
            {
                name: 'UnexpirePassword',
                visibleWhen: () => this.userdata && this.userdata.credentialsExpired && !this.userdata.locked && this.userdata.name !== 'anonymous',
                action: () => this.unexpirePassword(),
            },
            {
                name: 'DeleteUser',
                visibleWhen: () => this.mode === 'edit' && this.userdata && this.userdata.name !== 'anonymous',
                action: () => this.deleteUser(),
            },
        ]);

    }

    // Validations
    checkUserName(value) {
        return !(/[A-Z]/.test(value));
    }

}



// WEBPACK FOOTER //
// ./states/admin/security/users/user_form.controller.js